import * as React from 'react';
import * as I18n from 'i18n-js';
import * as classNames from 'classnames';
import AboutDirectCheckoutBullets from './about_direct_checkout_bullets';
import { reverbPaymentsImageStyleClass } from './reverb_payments_image';
import UrlHelpers from './shared/url_helpers';

interface Props {
  sellingFeePercent: number;
  shopCurrency: string;
  bankCountryCode: string;
}

export default function MarketpayPayoutsUpgradeAvailable(props: Props) {
  const { bankCountryCode, shopCurrency } = props;
  return (
    <div className="scaling-mb-2 padding-1 bd-1 bd--offwhite bd-rounded">
      <div className="dc-upgrade__ad">
        <p className="dc-upgrade__sub-heading">
          {I18n.t('discovery.payoutMethod.updateYourAccount')}
        </p>
        <h4 className="dc-upgrade__heading">
          {I18n.t('discovery.payoutMethod.switchToDirectCheckout')}
        </h4>
        <p className="dc-upgrade__paragraph">
          {I18n.t('discovery.payoutMethod.whyUpgrade')}
        </p>
      </div>
      <div className={classNames('payment-setup__provider-logo', reverbPaymentsImageStyleClass({ bankCountryCode, shopCurrency }))} />
      <AboutDirectCheckoutBullets
        sellingFeePercent={props.sellingFeePercent}
        shopCurrency={shopCurrency}
      />
      <div className="payment-setup">
        <div className="payment-setup__info">
          <a href={UrlHelpers.shopOnboardingSetupPath} className="btn btn-primary">
            {I18n.t('discovery.payoutMethod.getDirectCheckout')}
          </a>
        </div>
      </div>
    </div>
  );
}



// WEBPACK FOOTER //
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/src/components/marketpay_payouts_upgrade_available.tsx